var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-channel-approve',{attrs:{"campaignId":_vm.id},on:{"updateStatus":function($event){return _vm.updateStatus(_vm.status)}}}),_c('list-channel-approve',{attrs:{"id":_vm.id,"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }